<template>
  <div class="admin-job-applicants-container">
    <div v-if="!loading">
      <div v-if="showApplicantsList">
        <TopButtonsComponent
          :jobCreatorId="jobCreatorId"
          v-on:backToJobs="$emit('backToJobs', 'Jobs')"
          v-on:backToPostJob="$emit('backToPostJob', 'Post Job')"
        />

        <div class="admin-job-applicants-list-holder">
          <ListTable
            :headList="headList"
            :bodyList="currentJobsList"
            v-if="allApplicants"
            v-on:viewHandler="viewApplicant"
            v-on:enableHandler="enableApplicant"
            v-on:disableHandler="disableApplicant"
            v-on:deleteHandler="deleteApplicant"
          />
          <EmptyDashboardState
            v-if="!allApplicants"
            v-bind:emptyHeading="emptyStateTitle"
            v-bind:desc="jobDesc"
          />
        </div>

        <div class="pagination">
          <Pagination
            v-if="bodyList !== null"
            v-bind:itemsPerPage="itemsPerPage"
            v-bind:totalJobs="bodyList.length"
            v-bind:currentPage="currentPage"
            v-on:paginate="paginate"
          />
        </div>
    </div>
    <div v-else>
      <UserDetailsPage
        v-on:back="setView"
        :userDetailsData="userDetailsData"
      />
    </div>

      <!-- Modal component for actions confirmation -->
      <div v-if="showModal">
        <ActionModal
          :verb="modalVerb"
          :subject="modalSubject"
          v-on:modalAction="modalAction"
        />
      </div>
    </div>
    <!-- Loader Component -->
    <Loader v-if="loading" />
  </div>
</template>
<script>
import ListTable from '../../components/body/ListTable.vue';
import EmptyDashboardState from '../../components/EmptyDashboardState.vue';
import Pagination from '../../components/Pagination.vue';
import ActionModal from '../../components/Modals/ActionModal.vue';
import TopButtonsComponent from '../../components/JobDetail/TopButtonsComponent.vue';
import Loader from '../../components/body/Loader.vue';
import UserDetailsPage from './UserDetailsPage.vue';
import threeDotsIcon from '../../assets/images/tableDots.png';

export default {
  name: 'AdminJobApplicantsList',
  props: ['jobCreatorId'],
  components: {
    ListTable,
    EmptyDashboardState,
    Pagination,
    ActionModal,
    TopButtonsComponent,
    Loader,
    UserDetailsPage
  },
  data() {
    return {
      loading: false,
      allApplicants: null,
      headList: [
        {
          text: 'JOB SEEKERS',
        },
        {
          text: 'EMAIL',
        },
        {
          text: 'PHONE NO',
        },
        {
          text: 'TOTAL APPLICATIONS',
        },
        {
          text: 'LOCATION',
        },
        {
          text: '',
        },
      ],
      bodyList: null,
      showApplicantsList: true,
      emptyStateTitle: 'Candidates',
      jobDesc: 'Candidates Not Available',

      threeDotsIcon,
      currentPage: 1,
      itemsPerPage: 10,

      showModal: false,
      modalSubjectId: null,
      modalVerb: null,
      modalSubject: null,
    };
  },
  async mounted() {
    await this.getAllApplicants();
  },
  computed: {
    indexOfLastJob() {
      return this.currentPage * this.itemsPerPage;
    },

    indexOfFirstJob() {
      return this.indexOfLastJob - this.itemsPerPage;
    },

    currentJobsList() {
      return this.bodyList.slice(this.indexOfFirstJob, this.indexOfLastJob);
    },
  },
  methods: {
    setView(option){
      option === 'parent'?
        this.showApplicantsList = true : this.$emit('backToPostJob', 'Post Job');
    },
    viewApplicant(applicantId) {
      this.userDetailsData = this.allApplicants.find(applicant => {
        return applicant.id === applicantId;
      });
      this.showApplicantsList = false;
    },
    enableApplicant(applicantId) {
      this.showModal = !this.showModal;
      this.modalSubjectId = applicantId;
      this.modalVerb = 'enable';
      this.modalSubject = 'user';
    },
    disableApplicant(applicantId) {
      this.showModal = !this.showModal;
      this.modalSubjectId = applicantId;
      this.modalVerb = 'disable';
      this.modalSubject = 'user';
    },
    deleteApplicant(applicantId) {
      this.showModal = !this.showModal;
      this.modalSubjectId = applicantId;
      this.modalVerb = 'delete';
      this.modalSubject = 'user';
    },
    async modalAction(value) {
      //toggle modal
      this.showModal = !this.showModal;
      // decide action

      switch (true) {
        case (this.modalSubject === 'user' && this.modalVerb === 'enable'):
            value === 'yes' ?
              this.sendDispatchCall('enableUser', this.modalSubjectId)
              : this.closeModal();
          break;

        case (this.modalSubject === 'user' && this.modalVerb === 'disable'):
            value === 'yes' ?
              this.sendDispatchCall('disableUser', this.modalSubjectId)
              : this.closeModal();
          break;

        case (this.modalSubject === 'user' && this.modalVerb === 'delete'):
            value === 'yes' ?
              this.sendDispatchCall('deleteUser', this.modalSubjectId)
              : this.closeModal();
          break;

        default:
          break;
      }
    },
    sendDispatchCall(dispatchAction, entityId) {
      this.loading = true;
      this.$store.dispatch(dispatchAction, entityId)
          .then((res) => {
            if(res.response) {
              this.loading = false;
              this.$toastr.success(res.response ? res.response.message : res.response, 'Success');
              this.$router.go();
            } else if(res.error) {
              this.loading = false;
              this.$toastr.error(
                res.error.error ? res.error.error : res.error
                ? res.error.message : res.error,
                'Failed'
              );
            }
            this.closeModal();
          });
    },
    closeModal () {
      this.showModal = false;
      this.modalVerb = null;
      this.modalSubject = null;
      this.modalSubjectId = null;
    },
    paginate(pageNumber) {
      this.currentPage = pageNumber;
    },
    async getAllApplicants() {
      this.loading = true;
      await this.$store.dispatch('getAllApplicants').then(() => {
        this.allApplicants = this.$store.state.allApplicants;

        // Modify each applicant's data to suit table

        this.bodyList = [];
        this.allApplicants.forEach((applicant) => {
          let body = {
            fullName: `${applicant.firstName} ${applicant.lastName}`,
            email: applicant.emailAddress,
            phone: !applicant.phone ? '—' : applicant.phone,
            numberOfApplications: !applicant.myApplications.length
                ? '0'
                : applicant.myApplications.length,
            address: applicant.city && applicant.state ? `${applicant.city}, ${applicant.state}`
                  : applicant.city ? applicant.city
                  : applicant.state ? applicant.state
                  : '—',
            threeDotsIcon: threeDotsIcon,
            id: applicant.id,
            isEnabled: applicant.isEnabled,
            showDeleteButton: true
          };
          this.bodyList.push(body);
        });

        this.loading = false;
      });
    },

  },
};
</script>

<style scoped>
  .admin-job-applicants-list-holder {
    background: var(--white);
    border: 0.5px solid rgba(201, 201, 201, 0.35);
    box-sizing: border-box;
    box-shadow: 0px 14px 24px rgba(9, 44, 76, 0.1);
    border-radius: 10px 10px;
  }
  .pagination {
    margin-top: 30px;
    display: flex;
    justify-content: right;
    align-items: center;
  }
</style>
